module.exports = __webpack_public_path__ + "static/media/ai-user.ee6189e9.png";